module.exports = __webpack_public_path__ + "img/4.00fc6ad0.png";